import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatNumber } from './taskMapData';
export default function FertilizerPanelSummary({ average, area, summ, nutrient, soil = false }) {
    const rateUnit = nutrient === 'nitrogen' ? 'кг N/га' : 'кг/га';
    const massUnit = nutrient === 'nitrogen' ? 'кг N' : 'кг';
    const totalLabel = { nitrogen: 'Всего азота', phosphorus: 'Всего фосфора', potassium: 'Всего калия', fertility: 'Всего' }[nutrient];
    const metrics = [
        { label: soil ? 'Среднее содержание' : 'Средняя норма', value: formatNumber(average, 2), unit: soil ? 'мг/кг' : rateUnit },
        { label: 'Площадь расчёта', value: formatNumber(area, 2), unit: 'га' },
        ...(soil ? [] : [{ label: totalLabel, value: formatNumber(summ, 2), unit: massUnit }]),
    ];
    return React.createElement(Box, { component: "dl", "aria-label": "\u0418\u0442\u043E\u0433\u0438 \u0440\u0430\u0441\u0447\u0451\u0442\u0430", sx: { display: 'flex', flexWrap: 'wrap', gap: '12px 32px', m: 0, mb: 2 } }, metrics.map((metric) => React.createElement(Box, { key: metric.label, sx: { minWidth: 140 } },
        React.createElement(Typography, { component: "dt", variant: "caption", color: "text.secondary" }, metric.label),
        React.createElement(Typography, { component: "dd", variant: "h6", sx: { m: 0, fontSize: 22, fontWeight: 600, lineHeight: 1.6, fontVariantNumeric: 'tabular-nums' } },
            metric.value,
            " ",
            React.createElement(Box, { component: "span", sx: { fontSize: 14, fontWeight: 400 } }, metric.unit)))));
}
